var map = {
	"./Admin.vue": [
		"f529",
		"chunk-e5267ff6",
		"chunk-30d02b46"
	],
	"./AffiliateDashboard.vue": [
		"e51a",
		"chunk-18c81973",
		"chunk-e5267ff6",
		"chunk-6743d232",
		"chunk-359168a8",
		"chunk-1c836360"
	],
	"./BodyContent.vue": [
		"19a8",
		"chunk-6743d232",
		"chunk-626afe83"
	],
	"./CardSets.vue": [
		"aa09",
		"chunk-6743d232",
		"chunk-359168a8",
		"chunk-c982ddd2"
	],
	"./CardsContainer.vue": [
		"6136",
		"chunk-18c81973",
		"chunk-444af7f8",
		"chunk-5c4b690e"
	],
	"./CryptContent.vue": [
		"28fe",
		"chunk-18c81973",
		"chunk-6743d232",
		"chunk-444af7f8",
		"chunk-5c4b690e",
		"chunk-7663f7dd"
	],
	"./CryptTable.vue": [
		"c618",
		"chunk-18c81973",
		"chunk-1c7598f8"
	],
	"./DataIndicators.vue": [
		"daf8",
		"chunk-e5267ff6",
		"chunk-5b865543"
	],
	"./EventNotification.vue": [
		"cdb9"
	],
	"./MarketContent.vue": [
		"e7db",
		"chunk-359168a8",
		"chunk-627cb8b5"
	],
	"./NoMetaMask.vue": [
		"efad",
		"chunk-4a341039"
	],
	"./OthersAffiliateDashboard.vue": [
		"4cc2",
		"chunk-18c81973",
		"chunk-e5267ff6",
		"chunk-359168a8",
		"chunk-0d6a7498"
	],
	"./OthersCryptContent.vue": [
		"1d45",
		"chunk-18c81973",
		"chunk-444af7f8",
		"chunk-5c4b690e",
		"chunk-8b415010"
	],
	"./OwnedCardContent.vue": [
		"26be",
		"chunk-5c9a05e8"
	],
	"./OwnerBalances.vue": [
		"ebbc",
		"chunk-7f86b412"
	],
	"./RealtimeEvents.vue": [
		"a25f"
	],
	"./ShopContent.vue": [
		"161d",
		"chunk-6743d232",
		"chunk-444af7f8",
		"chunk-7b8c5459"
	],
	"./SortDropdown.vue": [
		"17f5",
		"chunk-6830be66"
	],
	"./TokenContent.vue": [
		"929b",
		"chunk-18c81973",
		"chunk-e5267ff6",
		"chunk-6743d232",
		"chunk-0f4e6a54"
	],
	"./TransactionModal.vue": [
		"203d"
	],
	"./UniverseBalances.vue": [
		"846b",
		"chunk-16a289d6"
	],
	"./charts/AffiliateChart.vue": [
		"be8c",
		"chunk-e5267ff6",
		"chunk-02caf4b2"
	],
	"./charts/AffiliateTable.vue": [
		"7510",
		"chunk-18c81973",
		"chunk-359168a8",
		"chunk-c4774f96"
	],
	"./charts/DoughnutChart.vue": [
		"ac27",
		"chunk-56d9d845",
		"chunk-2d2132dd"
	],
	"./charts/LineChart.vue": [
		"33e7",
		"chunk-56d9d845",
		"chunk-2d0b9bc8"
	],
	"./layout/AppFooter.vue": [
		"ec0b"
	],
	"./layout/CzxpRewardEffect.vue": [
		"36a5"
	],
	"./layout/Header.vue": [
		"96c7"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "0f13";
module.exports = webpackAsyncContext;